import { observer } from "mobx-react";
import useDashboardTranslation from "../../../../dashboard-translation/hooks/dashboard-translation-hook";
import newuserWelcome from "../../../../images/new-user-welcome.png";
import "./new-user-welcome-screen.scss";
import { IStepComponent } from "../../onboarding-page";
import WelcomeScreenStore from "../../stores/welcome-screen-store";
import OnBoardingScreenTitle from "../onboarding-screen-title/onboarding-screen-title";
import OnBoardingButton from "../onboarding-button/onboarding-button";

const NewUserWelcomeScreen: React.FC<IStepComponent> = observer((props) => {
    const store = props.store as WelcomeScreenStore;

    const scope = "dashboard-onboarding";
    const { getTranslation } = useDashboardTranslation();

    return (
        <div className="new-user-welcome-screen">
            <div className="new-user-onboarding-title-container">
                <OnBoardingScreenTitle
                    titleText={getTranslation("WELCOME_TITLE",scope)}
                    descriptionText={getTranslation("WELCOME_SUBTITLE",scope)}
                />
            </div>

            <OnBoardingButton
                buttonText={getTranslation("WELCOME_BUTTON",scope)}
                onClick={store.nextStep}
                isLoading={store.isLoading}
                paddingTop={45}
            />

            <div className="new-user-welcome-screen-image">
                <img src={newuserWelcome} alt="Welcome" />
            </div>
        </div>
    );

})

export default NewUserWelcomeScreen;